module.exports = __webpack_public_path__ + "static/media/securedBorrowedFunds.f0cbec9f.svg";